import { render, staticRenderFns } from "./CpyCategoryDetail.vue?vue&type=template&id=919d2154&scoped=true"
import script from "./CpyCategoryDetail.vue?vue&type=script&lang=js"
export * from "./CpyCategoryDetail.vue?vue&type=script&lang=js"
import style0 from "./CpyCategoryDetail.vue?vue&type=style&index=0&id=919d2154&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "919d2154",
  null
  
)

export default component.exports